import { render } from "./dice.vue?vue&type=template&id=10c93ced&scoped=true&ts=true"
import script from "./dice.vue?vue&type=script&lang=ts"
export * from "./dice.vue?vue&type=script&lang=ts"

import "./dice.vue?vue&type=style&index=0&id=10c93ced&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c93ced"]])

export default __exports__